import {
  SET_CURRENT_DOCUMENT,
  SET_DOCUMENT_LOADING,
  SET_LARGE_PAGE_LOADING,
  SET_CURRENT_PAGE,
  SEARCH,
  RELATED_SECTIONS,
  RELATED_DOCUMENTS,
  CLEAR_SEARCH,
  DOC_SEARCH,
  CLEAR_DOC_SEARCH,
  SEARCH_LOADING,
  DOC_SEARCH_LOADING,
} from './documentTypes';

const initialState = {
  loading: false,
  largePageLoading: false,
  currentDocument: null,
  relatedDocuments: null,
  currentPage: null,
  relatedPages: null,

  searchResults: null,
  pageSearchLoading: false,

  documentResults: null,
  docSearchLoading: false,
};

const DocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_DOCUMENT:
      return {
        ...state,
        currentDocument: action.payload,
        relatedDocuments: null,
        loading: false,
      };
    case RELATED_DOCUMENTS:
      return {
        ...state,
        relatedDocuments: action.payload,
        // loading: false,
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
        loading: false,
        largePageLoading: false,
        relatedPages: null,
      };
    case RELATED_SECTIONS:
      return {
        ...state,
        relatedPages: action.payload,
        // loading: false,
      };
    case SEARCH_LOADING:
      return {
        ...state,
        pageSearchLoading: true,
      };
    case SEARCH:
      return {
        ...state,
        searchResults: action.payload,
        pageSearchLoading: false,
      };
    case CLEAR_SEARCH:
      return {
        ...state,
        searchResults: null,
        pageSearchLoading: false,
      };
    case DOC_SEARCH_LOADING:
      return {
        ...state,
        docSearchLoading: true,
      };
    case DOC_SEARCH: {
      return {
        ...state,
        documentResults: action.payload,
        docSearchLoading: false,
      };
    }
    case CLEAR_DOC_SEARCH:
      return {
        ...state,
        documentResults: null,
        docSearchLoading: false,
      };
    case SET_DOCUMENT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_LARGE_PAGE_LOADING:
      return {
        ...state,
        largePageLoading: true,
      };
    default:
      return { ...state };
  }
};

export default DocumentReducer;
